import videoBlockMeta from './block.json';
import attributeVisibility from '@components/visibility/attributes.json'; // eslint-disable-line
import LinkControls from "@components/link/attributes.json"; // eslint-disable-line
import { getBlockLabelByName } from '@helpers/utils';
import './style.scss';
import edit from './edit';
import { videoIcon } from './icon';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = videoBlockMeta;

const attributes = {
  ...attributeVisibility,
  ...settings.attributes,
  ...LinkControls,
};

registerBlockType(name, {
  ...settings,
  icon: videoIcon,
  attributes,
  edit,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
